import { render, staticRenderFns } from "./AShareMarketCapGDP.vue?vue&type=template&id=4beda5e1&scoped=true"
import script from "./AShareMarketCapGDP.vue?vue&type=script&lang=js"
export * from "./AShareMarketCapGDP.vue?vue&type=script&lang=js"
import style0 from "./AShareMarketCapGDP.vue?vue&type=style&index=0&id=4beda5e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beda5e1",
  null
  
)

export default component.exports